import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { loadState } from "../stores/store";
import Dashboard from "../pages/dashboard/dashboard";

const PrivateRoute = ({ component: Outlet, allowedRoles }) => {  
    const auth = loadState();  
    const userRole = auth?.user?.role;  
    const isApplicationCompleted = auth?.user?.applicationCompleted === true;  
    
    if (auth && allowedRoles.includes(userRole) && isApplicationCompleted) {  
      return <Dashboard component={Outlet} />;  
    } else {  
      // Redirect to apply page if application is not completed  
      return <Navigate to="/apply" />;  
    }  
  };  

  const PublicRoute = ({ component: Outlet }) => {  
    const auth = loadState();  
    const location = useLocation();  
    const isApplyRoute = location.pathname === "/apply" || location.pathname === "/";  
    
    // Always allow access to the apply route  
    if (isApplyRoute && !auth?.user?.applicationCompleted) {  
      return <Outlet />;  
    }  
    
    const isAuthenticated = !!auth;  
    const isApplicationCompleted = auth?.user?.applicationCompleted === true;  
    
    if (!isAuthenticated || !isApplicationCompleted) {  
      // Allow access to public routes if not authenticated or application not completed  
      return <Outlet />;  
    } else {  
      // Redirect authenticated users with completed applications to private route  
      if (auth.user.role === "judge") {
        return <Navigate to="/judging" />;  
      } else if (auth.user.role === "admin") {
        return <Navigate to="/entries" />
      } else if (auth.user.role === "contestant") {
        return <Navigate to="/applications" />
      } else if (auth.user.role === "guardian") {
        return <Navigate to="/contestants" />
      }
      
    }  
  }; 

export { PrivateRoute, PublicRoute };  
